module.exports = __webpack_public_path__ + "img/Pic-msd.e9ca831a.jpg";